import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewSuperDistributor = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/super_distributer/add`, data);
  return res.data;
};
export const updateSuperDistributor = async (id, data) => {
  const res = await axios.patch(
    `${API_BASE_URL}/common?table=super_distributer&id=${id}`,
    data
  );
  return res.data;
};
export const updateDistributor = async (id, data) => {
  const res = await axios.patch(
    `${API_BASE_URL}/common?table=distributer&id=${id}`,
    data
  );
  return res.data;
};
export const getAllSuperDistributor = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/super_distributer?start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};
export const getSuperDistributorById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/super_distributer/${id}`);
  return res.data;
};

export const createNewDistributor = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/distributer/add`, data);
  return res.data;
};
export const getAllDistributor = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/distributer?&start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};
export const getDistributorById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/distributer/${id}`);
  return res.data;
};
